/**
 * Kish & Partners sysadmin check for the Admin Portal (ER-12719).
 *
 * Admin login only succeeds for superusers (`AdminLoginRequestSerializer`), so a
 * stored `adminToken` is proof of sysadmin when the login user payload omits
 * `is_superuser`. An explicit `is_superuser: false` still returns false so
 * non-sysadmin simulations and tests keep gated UI hidden.
 *
 * @returns {boolean}
 */
export function isAdminSysadmin() {
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      try {
        const user = JSON.parse(raw);
        if (user && user.is_superuser === true) return true;
        if (user && user.is_superuser === false) return false;
      } catch {
        // Corrupt user blob — fall through to adminToken (admin-login proves sysadmin).
      }
    }
    return Boolean(localStorage.getItem("adminToken"));
  } catch {
    return false;
  }
}
